import { types } from './actions';

const initialState = {
  apiToken: null,
  isAPITokenFetching: false,
  isAPITokenRevoking: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.FETCH_API_TOKEN_REQUEST:
      return {
        ...state,
        isAPITokenFetching: true,
      };
    case types.FETCH_API_TOKEN_SUCCESS:
      return {
        ...state,
        apiToken: payload.apiToken,
        isAPITokenFetching: false,
      };
    case types.GENERATE_NEW_API_TOKEN_REQUEST:
      return {
        ...state,
        isAPITokenFetching: true,
      };
    case types.GENERATE_NEW_API_TOKEN_SUCCESS:
      return {
        ...state,
        isAPITokenFetching: false,
        apiToken: payload.apiToken,
      };
    case types.REVOKE_API_TOKEN_REQUEST:
      return {
        ...state,
        isAPITokenRevoking: true,
      };
    case types.REVOKE_API_TOKEN_SUCCESS:
      return {
        ...state,
        isAPITokenRevoking: false,
        apiToken: null,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.integrations.apiToken;

export const getApiToken = (state) => getScope(state).apiToken;

export const getIsAPITokenFetching = (state) =>
  getScope(state).isAPITokenFetching;

export const getIsAPITokenRevoking = (state) =>
  getScope(state).isAPITokenRevoking;
